import { useCallback } from 'react';

import { MessageType } from 'dashboard/lib/interfaces/Message';
import { useLazyGetObjectSchemaQuery } from 'dashboard/redux/api/account-variable-definitions';
import { useLazyRTKErrorHandler } from 'lib/hooks/useRTKErrorHandler';

export const useObjectSchemas = () => {
  const [trigger] = useLazyGetObjectSchemaQuery();
  const { handleUseRTKError } = useLazyRTKErrorHandler();

  const getObjectSchema = useCallback(
    async (ref: string) => {
      const response = await trigger(ref);

      if (response.error) {
        handleUseRTKError({
          error: response.error,
          onError: () => ({
            message:
              'An unexpected error occurred while loading the account type. Some configuration features may be unavailable.',
            level: MessageType.Notice,
          }),
        });
        return null;
      }

      if (response.data?.oneOf?.length) {
        return response.data?.oneOf.find((schema) => schema?.$id === ref);
      }

      return response.data;
    },
    [trigger],
  );

  return { getObjectSchema };
};
